import React from 'react';
import { useTheme } from './ThemeProvider';
export function Logo({
  variant = 'wordmark'
}: {
  variant?: 'wordmark' | 'stacked';
}) {
  const {
    theme
  } = useTheme();
  if (variant === 'stacked') {
    return <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qUGbkR6QXzK69daBG2FpjJ/R3up_logo_green_1_logo_and_wordmark.png" alt="R3UP" className="h-16 w-auto" data-id="element-803" />;
  }
  return <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fvgNDaR1d9DZDZgmejQeUK/R3UP_logo_2_wordmark.png" alt="R3UP" className="h-10 w-auto" data-id="element-804" />;
}